//#region Imports
import React, { useEffect, useRef, useState } from "react";
//MUI
import { Box, Button, Popover, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import eOpsLogo from "../../images/eops.png";
import excel from "../../images/excel.png";
import mepcoLogo from "../../images/mepcoLogo.png";
import pdf from "../../images/pdf.png";
import print from "../../images/print.png";
import { cfpBaseUrl } from "../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
} from "../../services/Functions";
import { internalIconStyles } from "../../style/common";
import "../../style/common.scss";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
//#endregion

/** Wiring Test Report (id 21) should appear after Document Verification (id 1) in the Current Stage dropdown. */
function reorderNewConnectionProgressStages(stages) {
  if (!Array.isArray(stages) || stages.length < 2) {
    return Array.isArray(stages) ? [...stages] : [];
  }

  const getId = (s) => {
    const v = s.progressId ?? s.applicationProgressId;
    if (v === undefined || v === null || v === "") return NaN;
    return Number(v);
  };

  const wiringIndex = stages.findIndex((s) => getId(s) === 21);
  if (wiringIndex === -1) {
    return [...stages];
  }

  const next = [...stages];
  const [wiringStage] = next.splice(wiringIndex, 1);
  const docVerifyIndex = next.findIndex((s) => getId(s) === 1);
  if (docVerifyIndex === -1) {
    return [...stages];
  }

  next.splice(docVerifyIndex + 1, 0, wiringStage);
  return next;
}

const NewConnectionStatusReport = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId } =
    useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [categoryNames, setCategoryNames] = useState("All");
  const [ripeStatusName, setRipeStatusName] = useState("Ripe");
  const [tableData, setTableData] = useState([]);
  // const [officeCode, setOfficeCode] = useState('');
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState(3);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [selectedStage, setSelectedStage] = useState(100);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [connectionCategory, setConnectionCategory] = useState("All");
  const [connectionTypeOptions, setConnectionTypeOptions] = useState([]);
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [ripeStatus, setRipeStatus] = useState(1);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const companyCode = code.slice(0, 2);
  const [progressStages, setProgressStages] = useState([]);
const [selectedProgressId, setSelectedProgressId] = useState(100);   // Default = All
const [selectedStageName, setSelectedStageName] = useState("All");
  const offCode = code;
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // Fetch Application Progress Stages + Add "All" Option
useEffect(() => {
  const fetchProgressStages = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationTypeId: "1" });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "comman/getApplicationProgressIdsByType",
        requestOptions
      );

      const result = await response.json();

      if (result.status === "200" && result.data) {
        const orderedStages = reorderNewConnectionProgressStages(result.data);
        // Add "All" option at the beginning
        const stagesWithAll = [
          {
            progressId: 100,
            stepName: "All"
          },
          ...orderedStages
        ];

        setProgressStages(stagesWithAll);

        // Default to All
        setSelectedProgressId(100);
        setSelectedStageName("All");
      }
    } catch (error) {
      console.error("Error fetching progress stages:", error);
    }
  };

  if (token) {
    fetchProgressStages();
  }
}, [token]);
  // Fetch connection types from API
  useEffect(() => {
    const fetchConnectionTypes = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: "",
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "enc/getConnectionTypes",
          requestOptions
        );
        const result = await response.json();

        if (result.status === "200" && result.data) {
          setConnectionTypeOptions(result.data);
        }
      } catch (error) {
        console.error("Error fetching connection types:", error);
      }
    };

    if (token) {
      fetchConnectionTypes();
    }
  }, [token]);


  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
      else if (cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 5));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    boldDomTheadRows(wb.Sheets[wb.SheetNames[0]], tableRef.current, 0);
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const Filters = `${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
      category === 1 || category === 2 ? " - " + ripeStatusName : ""
    }`;
    const filename = `${officeName}- From ${dateFrom} - to ${dateTo} - New-Connection-Status-Report (${Filters}).xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const currentFilters = {
    dateFrom,
    dateTo,
    selectedCompanyCode: code === 10 ? selectedCompanyCode : null,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    connectionCategory,
    selectedProgressId,
    category,
    ripeStatus: category === 2 ? ripeStatus : null,
    officeCode,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    dateFrom,
    dateTo,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    connectionCategory,
    selectedProgressId,
    category,
    ripeStatus,
    officeCode,
  ]);

  // نیا Go button handler
  const handleGoClick = () => {
    getStats(officeCode, dateFrom, dateTo, category);
    setLastAppliedFilters({ ...currentFilters });
    setIsGoDisabled(true);
  };
  const connectionTypes = [
    "Sr No.",
    "Application Id.",
    "Registration Date",
    "Applicant Name",
    "Phone No.",
    "CNIC.",
    "Permissess Address",
    "Reference No.",
    "Load",
    "Tariff",
    "DN Issue Date",
    "Capital Cost",
    "Security Cost",
    "Total DN Amount",
    "DN Payment Date",
    "SCO Creation Date",
    "Meter No.",
    "Transformer Ref No.",
    "Feeder No.",
    "GIS Code",
    "SR Date",
    "SR Number",
    "Meter Installation Date",
    "Last Modification Date",
    "Last Modified By",
    "Remarks",
  ];

  const [categoryName, setcategoryName] = useState("All");

  const getStats = async (officeCode, dateFrom, dateTo, status) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        officeCode: officeCode,
        applicationProgressId: selectedProgressId,
        connectionType: connectionCategory,
        status: category,
        ripeUnripe: category === 0 || category === 1 ? 0 : ripeStatus,
        dateFrom: dateFrom ? dateFrom : "",
        dateTo: dateTo ? dateTo : "",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      await fetch(
        cfpBaseUrl + "enc/getNewConnectionProgressReport",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            const data = result.data;
            console.log(data, "Consollling Data");

            setTableData(data);
          } else if (result.status === "400") {
            setTableData([]);
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e);
    }
    setViewBackdrop(false);
  };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);

      const title =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
          ? `New Connection Status Report of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
              category === 2 ? " - " + ripeStatusName : ""
            })`
          : `${dateFrom ? convertDate(dateFrom) : "-"} to ${
              dateTo ? convertDate(dateTo) : "-"
            } of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
              category === 2 ? " - " + ripeStatusName : ""
            })`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );
      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `New Connection Status Report for ${officeName}`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      // PDF should exclude detailed DN/SCO/meter columns — keep concise
      const headers = [
        { content: "Sr No.", styles: { halign: "left" } },
        { content: "Application ID", styles: { halign: "left" } },
        { content: "Registration Date", styles: { halign: "left" } },
        { content: "Applicant Name", styles: { halign: "left" } },
        { content: "Phone No.", styles: { halign: "left" } },
        { content: "CNIC.", styles: { halign: "left" } },
        { content: "Premises Address", styles: { halign: "left" } },
        { content: "Reference No.", styles: { halign: "left" } },
          { content: "Load", styles: { halign: "left" } },
        { content: "Last Modification Date", styles: { halign: "left" } },
        { content: "Last Modified By", styles: { halign: "left" } },
        { content: "Remarks", styles: { halign: "left" } },
      ];

      let bodyData = [];

      if (tableData && tableData.length > 0) {
        // Build PDF row but exclude DN/SCO/meter columns so PDF is compact
        bodyData = tableData.map((item, index) => [
          { content: index + 1, styles: { halign: "center" } },
          { content: item.applicationId || "-", styles: { halign: "left" } },
          { content: item.creationDate ? formatDate(item.creationDate) : '-', styles: { halign: "left" } },
          { content: item.applicantName || "-", styles: { halign: "left" } },
          { content: item.applicantMobile || "-", styles: { halign: "left" } },
          { content: item.applicantCNIC || "-", styles: { halign: "left" } },
          { content: item.premisesAddress || "-", styles: { halign: "left" } },
          { content: item.referenceNo || "-", styles: { halign: "left" } },
          { content: item.appliedLoad || "-", styles: { halign: "left" } },
          { content: item.lastModificationDate ? formatDate(item.lastModificationDate) : "-", styles: { halign: "left" } },
          { content: item.lastModifiedBy || "-", styles: { halign: "left" } },
          { content: item.remarks || "-", styles: { halign: "left" } },
        ]);
      } else {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: headers.length,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: {
          cellPadding: 0.5,
          fontSize: 8,
          halign: "left",
          overflow: "linebreak",
        },
        tableWidth: "auto",
        theme: "striped",
        margin: { left: 10, right: 10 },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 30 },
          2: { cellWidth: 20 },
          3: { cellWidth: 23 },
          4: { cellWidth: 23 },
          5: { cellWidth: 23 },
          6: { cellWidth: 35 },
          7: { cellWidth: 25},
          8: { cellWidth: 20 },
          9: { cellWidth: 20 },
          10: { cellWidth: 20 },
          11: { cellWidth: 30 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(8);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      const Filters = `${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
        category === 1 || category === 2 ? " - " + ripeStatusName : ""
      }`;

      if (print) {
        pdf.save(
          `${officeName}- From ${dateFrom} - to ${dateTo} - New-Connection-Status-Report (${Filters}).pdf`
        );
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return "-";
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const getDateDifference = (startDate, endDate) => {
    // Convert the date strings to Date objects
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];

    const start = new Date(startDates);
    const end = new Date(endDates);

    // Calculate the difference in time (milliseconds)
    const differenceInTime = end - start;

    // Convert time difference from milliseconds to days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    return differenceInDays;
  };

  const handleRemarksClick = (event, remarks) => {
    if (remarks && remarks.trim() !== "") {
      // Only show popover if remarks have a value
      setAnchorEl(event.currentTarget); // Set the target element for Popover
      setSelectedRemarks(remarks);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);


  

  // status change
  const handleStatusChange = (e) => {
    const selectedValue = Number(e.target.value);
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    setCategory(selectedValue);
    setCategoryNames(selectedLabel);
  };
  const handleCategoryChange = (e) => {
    const selected = e.target.value;
    setConnectionCategory(selected);
  };

  const handleRipeorUnripeChange = (e) => {
    const selectedValue = Number(e.target.value);
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setRipeStatus(selectedValue);
    setRipeStatusName(selectedLabel);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };
  
  return (
    <>
      {/* Applications Table */}
      <Box className="form-box">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Box className="application-table" style={{ marginRight: "10px" }}>
            <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
              New Connection Status Report
            </h3>
            <div className="div-datagrid">
              <div className="reports-container">
                <div
                  className="filter-fields"
                  style={{ width: "90%", gap: "15px" }}
                >
                  <div className="field-container">
                    <Typography className="field-label"> Date From</Typography>
                    <input
                      type="date"
                      className="date-field"
                      value={dateFrom}
                      onChange={(e) => {
                        setDateFrom(e.target.value);
                      }}
                    />
                  </div>
                  <div className="field-container">
                    <Typography className="field-label"> Date To</Typography>
                    <input
                      type="date"
                      className="date-field"
                      value={dateTo}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => {
                        setDateTo(e.target.value);
                      }}
                    />
                  </div>
                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedCompanyCode}
                        onChange={(e) => {
                          handleChangeCompany(e);
                        }}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={circleCode || ""}
                        onChange={(e) => {
                          handleCircleChange(e);
                        }}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedDivision || ""}
                        onChange={(e) => {
                          handleDivisionChange(e);
                        }}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedSubDivision || ""}
                        onChange={(e) => {
                          handleSubDivisionChange(e);
                        }}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="field-container">
                    <label className="field-label">Connection Type:</label>
                    <select
                      className="dropdown-field"
                      style={{ backgroundColor: "white" }}
                      id="connectionType"
                      value={connectionCategory}
                      onChange={(e) => {
                        handleCategoryChange(e);
                      }}
                    >
                      <option value="All">All</option>
                      {connectionTypeOptions.map((type) => (
                        <option
                          key={type.connectionTypeId}
                          value={type.connectionTypeName}
                        >
                          {type.connectionTypeName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="field-container">
  <label className="field-label">Current Stage:</label>
  <select
    className="dropdown-field"
    style={{ backgroundColor: "white" }}
    value={selectedProgressId}
    onChange={(e) => {
      const selectedId = Number(e.target.value);
      setSelectedProgressId(selectedId);

      const selectedStage = progressStages.find(
        (stage) => stage.progressId === selectedId
      );
      
      setSelectedStageName(selectedStage ? selectedStage.stepName.trim() : "All");
    }}
  >
    {progressStages.map((stage) => (
      <option 
        key={stage.progressId} 
        value={stage.progressId}
      >
        {stage.stepName.trim()}
      </option>
    ))}
  </select>
</div>
                  <div className="field-container">
                    <Typography className="field-label">Status</Typography>
                    <select
                      className="dropdown-field"
                      style={{ backgroundColor: "white" }}
                      value={category}
                      onChange={(e) => {
                        handleStatusChange(e);
                      }}
                    >
                      <option value={3}>All</option>
                      <option value={1}>Objected</option>
                      <option value={0}>Pending</option>
                      <option value={2}>Accepted</option>
                    </select>
                  </div>
                  {category === 2 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Ripe/Un-Ripe
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={ripeStatus}
                        onChange={(e) => {
                          handleRipeorUnripeChange(e);
                        }}
                      >
                        <option value={1}>Ripe</option>
                        <option value={0}>Unripe</option>
                      </select>
                    </div>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "10px" }}
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    Go
                  </Button>
                </div>
                <div
                  className="export-button-container"
                  style={{ width: "10%" }}
                >
                    <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="table-container" style={{ marginBottom: "40px" }}>
                <div id="pdf-table">
                  <div style={{ maxHeight: "900px", overflowY: "auto" }}>
                    <table
                      className="table"
                      ref={tableRef}
                      style={{
                        marginBottom: "40px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        <tr
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 3,
                          }}
                        >
                          <th
                            colSpan={connectionTypes.length}
                            style={{
                              fontSize: "14px",
                              borderBottom: "2px solid white",
                              textAlign: "center",
                              backgroundColor: "#d5e5ff",
                              color: "black",
                            }}
                          >
                            {dateFrom &&
                            dateTo &&
                            convertDate(dateFrom) === convertDate(dateTo)
                              ? `New Connection Status Report for (${officeName}) of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
                                  category === 2 ? " - " + ripeStatusName : ""
                                })`
                              : `New Connection Status Report for (${officeName}) from ${
                                  dateFrom ? convertDate(dateFrom) : "-"
                                } to ${
                                  dateTo ? convertDate(dateTo) : "-"
                                } of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
                                  category === 2 ? " - " + ripeStatusName : ""
                                })`}
                          </th>
                        </tr>
                        <tr
                          style={{
                            position: "sticky",
                            top: "37px",
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          {connectionTypes.map((type, index) => (
                            <th
                              key={index}
                              style={{
                                width: `${100 / connectionTypes.length}%`,
                                textAlign: "left",
                                border: "5px solid white",
                                // backgroundColor: '#d5e5ff',
                                // color: 'black',
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "12px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              {type}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.length > 0 ? (
                          tableData.map((item, id) => (
                            <tr
                              key={id}
                              style={{
                                backgroundColor: "white",
                                borderBottom: "1px solid #ccc",
                              }}
                            >
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>{id + 1}</td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.applicationId || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.creationDate ? formatDate(item.creationDate) : '-'}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.applicantName || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.applicantMobile || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.applicantCNIC || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.premisesAddress || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.referenceNo || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.appliedLoad || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.tariff || "-"}
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item.issueDate ? formatDate(item.issueDate) : "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.capitalCostAmount || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.securityDepositeAmount || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {(
                                  (Number(item.capitalCostAmount) || 0) +
                                  (Number(item.securityDepositeAmount) || 0)
                                ) || item.dNamount || item.totalDNAmount || item.demandNoticeAmount || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.paymentDate? formatDate(item.paymentDate) : "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.scoCreationDate ? formatDate(item.scoCreationDate) : "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.meterNo || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.transformerRefNo || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.feederNo || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.installedTransformerCapacity || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.storeRequisitionDate ? formatDate(item.storeRequisitionDate) : "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.storeRequisitionNo || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.dateOfConnection ? formatDate(item.dateOfConnection) : "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.lastModificationDate ? formatDate(item.lastModificationDate) : "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.lastModifiedBy || "-"}
                              </td>
                              <td style={{ textAlign: "left", fontSize: "11px", padding: "6px 8px" }}>
                                {item.remarks || "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                                colSpan={connectionTypes.length}
                                style={{
                                  textAlign: "center",
                                  padding: "10px",
                                  fontWeight: "bold",
                                  color: "red",
                                  backgroundColor: "#d5e5ff",
                                }}
                              >
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Box>
      {/* Popover for showing full Remarks */}
      {selectedRemarks && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableRestoreFocus
        >
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" sx={{ fontSize: "17px" }}>
              Remarks :
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{selectedRemarks}</Typography>
          </div>
        </Popover>
      )}
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default NewConnectionStatusReport;
